import * as Yup from 'yup';
import { messages } from 'app/config/constants';

const mandatoryCodebook = () => Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD);

export const specialBuildingPartValidationSchema = Yup.object({
  building: mandatoryCodebook(),
  buildingPart: mandatoryCodebook(),
  specialBuildingPart: mandatoryCodebook(),
  spaceType: mandatoryCodebook(),
  usefulNetArea: Yup.number().required(messages.MANDATORY_FIELD).typeError(messages.MANDATORY_FIELD).min(0),
  floor: mandatoryCodebook(),
  floorType: mandatoryCodebook(),
  roomCount: mandatoryCodebook(),
  livingRoomCount: mandatoryCodebook(),
  kitchenCount: mandatoryCodebook(),
  bathroomCount: mandatoryCodebook(),
  separateToiletCount: mandatoryCodebook(),
  disabilityAdaptation: mandatoryCodebook(),
  elevatorAccess: mandatoryCodebook(),
  waterSupplyConnection: mandatoryCodebook(),
  sewageConnection: mandatoryCodebook(),
  electricityConnection: mandatoryCodebook(),
  gasConnection: mandatoryCodebook(),
  internetConnection: mandatoryCodebook(),
  heatingConnection: mandatoryCodebook(),
  heatingEnergySource: mandatoryCodebook(),
  coolingConnection: mandatoryCodebook(),
  note: Yup.string().nullable(),
});
